import React from "react";
import ReactDOM from "react-dom";
import env from "env";
import { startMockServer } from "./setupDevEnv";
import BaseProvider, { Logger } from "@base-provider";
import { reducers } from "./redux/reducers";
import { translations } from "./languages";
import App from "./app";
import { SFThemeProvider } from "@sf-core";
import "@sf-core/assets/css/index.scss";
import { ROUTES } from "./constants/routes";

async function initApp() {
  if (env.REACT_APP_ENABLE_MOCK_API) {
    startMockServer();
  }

  let _env = { ...env };
  if (process.env.REACT_APP_EYWP_MFE_ENV_FILE && !env.REACT_APP_IS_LOCAL) {
    const response = await fetch(process.env.REACT_APP_EYWP_MFE_ENV_FILE);
    const _jsonEnv = await response.json();
    _env = { ...env, ..._jsonEnv };
  }
  Logger.of("App.Environment").info({ env, _env });

  ReactDOM.render(
    <React.StrictMode>
      <BaseProvider
        config={{
          reducers,
          translations,
          themeProvider: SFThemeProvider,
          apiEndpoints: { base: _env.REACT_APP_API_ENDPOINT },
          auth0Config: {
            auth: {
              clientId: _env.REACT_APP_AUTH0_CLIENT_ID,
              domain: _env.REACT_APP_AUTH0_DOMAIN,
              scope: _env.REACT_APP_AUTH0_SCOPE,
              audience: _env.REACT_APP_AUTH0_AUDIENCE,
            },
          },
          appInsights: {
            enable: _env.REACT_APP_ENABLE_APPLICATION_INSIGHTS,
            instrumentationKey: _env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
          },
          forceTenant: _env.REACT_APP_FORCE_TENANT,
          appName: "Launchpad",
          authInstance: _env.REACT_APP_AUTH_INSTANCE,
        }}
      >
        <App routes={ROUTES} />
      </BaseProvider>
    </React.StrictMode>,
    document.getElementById("root"),
  );
}

initApp();